import { SpinnerElement } from "./SpinnerStyles";

export default function Spinner() {
  return (
    <SpinnerElement>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </SpinnerElement>
  );
}
